import $ from "jquery";
import * as GC from "../../../../common/common";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../functions/callBackFunctions";

export default function standart() {}

export const fillDetail = () => {
  // var test = window.$catalog_management_units_selectedRow;
  // $("#algemeenNaam").html(
  //   window.$catalog_management_units_selectedRow.algemeenNaam
  // );
  // $("#algemeenNaam-tooltip").html(
  //   window.$catalog_management_units_selectedRow.algemeenNaam
  // );
  // $("#algemeenCode").html(
  //   window.$catalog_management_units_selectedRow.algemeenCode
  // );
  // $("#endDate").attr(
  //   "placeholder",
  //   window.$catalog_management_units_selectedRow.endDate
  // );
  // $("#startDate").attr(
  //   "placeholder",
  //   window.$catalog_management_units_selectedRow.startDate
  // );
  // if (window.$catalog_management_units_selectedRow.isActive)
  //   $("#beheereenheid_active").attr("checked", "checked");
  // else $("#beheereenheid_active").removeAttr("checked");

  // //editSide
  // $("#e-algemeenNaam").val(
  //   window.$catalog_management_units_selectedRow.algemeenNaam
  // );
  // $("#e-algemeenCode").val(
  //   window.$catalog_management_units_selectedRow.algemeenCode
  // );
  // $("#e-identification").val(
  //   window.$catalog_management_units_selectedRow.identification
  // );

  // if (window.$catalog_management_units_selectedRow.isActive)
  //   $("#e-beheereenheid_active").attr("checked", "checked");
  // else $("#e-beheereenheid_active").removeAttr("checked");
  // var startDate = String(
  //   window.$catalog_management_units_selectedRow.startDate.replaceAll("-", "/")
  // );
  // startDate =
  //   startDate.split("/")[1] +
  //   "/" +
  //   startDate.split("/")[0] +
  //   "/" +
  //   startDate.split("/")[2];
  // var endDate = String(
  //   window.$catalog_management_units_selectedRow.endDate.replaceAll("-", "/")
  // );
  // endDate =
  //   endDate.split("/")[1] +
  //   "/" +
  //   endDate.split("/")[0] +
  //   "/" +
  //   endDate.split("/")[2];
  // startDate = new Date(startDate);
  // endDate = new Date(endDate);

  // document.getElementById("e-startDate").value = GC.FormatDateReverse(
  //   startDate,
  //   "date"
  // );
  // document.getElementById("e-endDate").value = GC.FormatDateReverse(
  //   endDate,
  //   "date"
  // );
  // $("#e-endDate").attr("min", GC.FormatDateReverse(startDate, "date"));
};

export const rowsHandleDelete = () => {
  // 1. bu kayıtın relationlarını getir.
  // 2. tüm relationlarını sil.
  // 3. sonra kayıtı sil.
  $("#cover-spin").show(0);
  var BreakException = {};
  window.$catalog_management_units_selectedIds.forEach(async (element) => {
    try {
      let getRowOfDetail = await omnimap.GetActionsOfRowAction(
        element,
        window.$catalog_management_units_token
      );

      // if (getRowOfDetail.data.delete_allowed) {
      //   throw BreakException;
      // }

      let realtions = await omnimap.GetRelationAction(
        element,
        1,
        30,
        window.$catalog_management_units_token
      );

      /**
       * * 1. silinmek istenen kayıtın beheerobject ilişkisi varsa sinemez olması gerekmektedir
       */

      if (realtions.data !== undefined) {
        await realtions.data.forEach(async (relation) => {
          let result = await omnimap
            .DeleteRelationAction(
              relation.identification,
              window.$catalog_management_units_token
            )
            .catch((error) => {
              console.log(error);
            });
          var test = "";
        });
      }

      GC.sleep(2000).then(async () => {
        let result = await omnimap
          .Delete(element, window.$catalog_management_units_token)
          .catch((error) => {
            console.log(error);
          });

        CallBackFunctions.RowsDeletedCallBack(
          window.$catalog_management_units_token
        );
      });
    } catch (e) {
      if (e !== BreakException) throw e;
    }
  });
};
